import { FloatingPanelTrigger } from "@bcc-ui/ui-components";
import classNames from "classnames";
import * as React from "react";

import style from "./ai-panel-button.scss";
import { Logo } from "components/logo/Logo";
import { resolveColor } from "utils/commonFunctions";

import testIds from "testIds.json";

interface Props {
    isLoading: boolean;
}

export const AiPanelButton = (props: Props) => {
    return (
        <FloatingPanelTrigger className={style.trigger}>
            <Logo className={style.icon} hiddenText isWhiteLogo />
            {props.isLoading && (
                <svg
                    className={classNames(style.loadingIndicator, { [style.isVisible]: props.isLoading })}
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    data-testid={testIds.common.inProgressElement}
                >
                    <circle cx="24" cy="24" r="22.5" stroke="url(#paint0_linear_1201_10930)" strokeWidth="3" />
                    <defs>
                        <linearGradient
                            id="paint0_linear_1201_10930"
                            x1="6.5"
                            y1="24"
                            x2="48"
                            y2="24"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stopColor={resolveColor("--app-theme-brand-blue")} />
                            <stop offset="1" stopColor="#A8EAFE" />
                        </linearGradient>
                    </defs>
                </svg>
            )}
        </FloatingPanelTrigger>
    );
};
